export enum FeedSortMode {
    New = 0,
    Trending = 1,
    TopThisWeek = 2,
    TopThisMonth = 3,
    TopThisYear = 4,
    TopAllTime = 5,
    Random = 6
};